/*
 * Copyright (c) 2018 by Filestack.
 * Some rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import * as tslib_1 from "tslib";
var FilestackError = /** @class */ (function (_super) {
    tslib_1.__extends(FilestackError, _super);
    function FilestackError(message, details) {
        var _this = _super.call(this, message) || this;
        Object.setPrototypeOf(_this, FilestackError.prototype);
        _this.details = details;
        return _this;
    }
    return FilestackError;
}(Error));
export { FilestackError };
